import * as Yup from 'yup';
import { Dto } from "../../../parts/crud/dto";




export class LicencesDto extends Dto {
  constructor() {
    super();
    this.data.initialValues = {

      fk_group_id: '',
      expiration: '',
      name: '',
      tokens: ''
    };


    this.data.validationSchema = Yup.object({
      name: Yup.string().required('Il campo nome è obbligatorio'),
      fk_group_id: Yup.object().required('Il campo Tenant è obbligatorio'),
      expiration: Yup.string().required('Il campo data di scadenza è obbligatorio'),
      tokens: Yup.number().required('Il campo numero di licenze è obbligatorio')
    })
  }

  updateData(data){
    super.updateData(data);
    this.data.initialValues.expiration = data.data.expiration.split('T')[0];

  }
}